<template>
  <Modal
    v-model="_value"
    width="400"
    title="ZT重启控制"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="110">
      <FormItem prop="agreementChannel" label="部标协议通道" show-message>
        <Select v-model="setDriverCardParams.agreementChannel" style="width: 220px;">
          <Option v-for="item in agreementChannelOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
    </Form>
  </Modal>
</template>

<script>

  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'


  export default {
    name: 'ztsetdriverrestartmodal',
    components: {},
    props: {
      initValue: null,
      terminalNumValue: null,
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        setDriverCardParams: {
          id: null,
          agreementChannel: 0,
        },
        //协议通道
        agreementChannelOptions: [
          {name: '无', value: 0},
          {name: '部标主服务器', value: 1},
          {name: '部标备服务器', value: 2},
          {name: '部标扩一服务器', value: 3},
          {name: '部标扩二服务器', value: 4},
          {name: '部标扩三服务器', value: 5},
        ],

      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_SearchByName'
      ]),
      visibleChange(val) {
        if (val) {
          this.setDriverCardParams.id = this._initValue
          this.setDriverCardParams.agreementChannel = 0
        }
      },
      onCleanDriverCardParams() {
        this.setDriverCardParams.agreementChannel = 0
      },
      onSendDriverCardParams() {

        let content = '##_ZTTtsSet;终端重启控制;'
          + '重启机器' + ','
        if (this.setDriverCardParams.agreementChannel != 0){
          content += '重启部标协议='+this.setDriverCardParams.agreementChannel + ','
        }
        content = content.substring(0,content.length-1)
        content += '$'
        console.log(content)


        store.dispatch('NetCommandServ_SendCommand', {
          params: {
            id: this._initValue,
            content: content,
            urgent: false
          }
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    computed: {
      _value: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _terminalNumValue: {
        get() {
          return this.terminalNumValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
